import { FooterNormalController } from "./footerNormal.controller"

let PageModule_name = "qpmn-footer";

angular.module(PageModule_name, [])
    .controller({
        footerNormalController: FooterNormalController,
    })

export { PageModule_name };